var _a;
import { createSlice } from "@reduxjs/toolkit";
export var defaultState = {
    productCart: [],
    totalPrice: 0,
};
export var productCartReducer = createSlice({
    name: "productCart",
    initialState: defaultState,
    reducers: {
        addCartItem: function (state, action) {
            var _a = action.payload, id = _a.id, title = _a.title, price = _a.price, quantity = _a.quantity;
            var existingItem = state.productCart.find(function (item) { return item.id === id; });
            if (existingItem) {
                existingItem.quantity += quantity;
            }
            else {
                state.productCart.push({ id: id, title: title, price: price, quantity: quantity });
            }
            state.totalPrice += price * quantity;
        },
        removeCartItem: function (state, action) {
            var itemId = action.payload;
            var itemToRemove = state.productCart.find(function (item) { return item.id === itemId; });
            if (itemToRemove) {
                state.totalPrice -= itemToRemove.price * itemToRemove.quantity;
                state.productCart = state.productCart.filter(function (item) { return item.id !== itemId; });
            }
        },
    },
});
export var addCartItem = (_a = productCartReducer.actions, _a.addCartItem), removeCartItem = _a.removeCartItem;
export default productCartReducer.reducer;
